
import axios from 'axios'
import Conf from '../router/Conf'
import wx from 'weixin-js-sdk';
import { Toast } from 'vant'
import NativeShare from "nativeshare";

export let wxShareUtil = function () {
	this.shareConfig = {};
	this.shareInfo = {};
	this.shareUrl = null;
	this.chkWeiXin = function() {
		var ua = window.navigator.userAgent.toLowerCase();
		return (ua.indexOf('micromessenger') > -1);
	};
	this.shareOptions = function(){
		let isWxEnv = this.chkWeiXin();
		let shareOptions = [
			[
				{ name: '微信', icon: 'wechat' , description :isWxEnv?'点击右上角 ··· 分享！':''},
				{ name: '朋友圈', icon: 'https://img.yzcdn.cn/vant/share-icon-wechat-moments.png' , description :isWxEnv?'点击右上角 ··· 分享！':''},
				{ name: '微博', icon: 'weibo', description :isWxEnv?'点击右上角 ··· 分享！':'' },
				{ name: 'QQ', icon: 'qq', description :isWxEnv?'点击右上角 ··· 分享！':'' }
			],
			[
				{ name: '复制链接', icon: 'link' },
				{ name: '二维码', icon: 'qrcode' },
				{ name: 'QQ空间', icon: require('../assets/img/icon/qqzone.png') , description :isWxEnv?'点击右上角 ··· 分享！':''}
			]
		];
		return shareOptions;
	}
	this.initWxConfig = function(){
		let that = this;
		console.log("----------initWxConfig---------------")
		if(that.shareConfig.appid){
			wx.config({ //  通过后端
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
				appId: that.shareConfig.appid, // 必填，公众号的唯一标识
				timestamp: that.shareConfig.timestamp, // 必填，生成签名的时间戳
				nonceStr: that.shareConfig.nonceStr, // 必填，生成签名的随机串
				signature: that.shareConfig.signature, // 必填，签名，见附录1
				jsApiList: ['updateTimelineShareData','updateAppMessageShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
			});
			wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
				wx.updateAppMessageShareData({ 
					title: that.shareInfo.title, // 分享标题
					desc: that.shareInfo.desc, // 分享描述
					link: that.shareInfo.link.replace('#','?#'), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: that.shareInfo.imgUrl, // 分享图标
					success: function () {
					  // 设置成功
					}
				});

				wx.updateTimelineShareData({ 
					title: '【'+that.shareInfo.title+'】'+that.shareInfo.desc, // 分享标题
					link: that.shareInfo.link.replace('#','?#'), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: that.shareInfo.imgUrl, // 分享图标
					success: function () {
					  // 设置成功
					}
				});

				wx.onMenuShareWeibo({
					title: that.shareInfo.title, // 分享标题
					desc: that.shareInfo.desc, // 分享描述
					link: that.shareInfo.link.replace('#','?#'), // 分享链接
					imgUrl: that.shareInfo.imgUrl, // 分享图标
					success: function () {
						// 用户确认分享后执行的回调函数
					},
					cancel: function () {
						// 用户取消分享后执行的回调函数
					}
				});
			});
		}
	}
	this.init = function(uri, shareInfo){
		this.shareUrl = uri;
		this.shareInfo = shareInfo;
		let that = this;
		var url = Conf.serverUrl + "Common/wxjsdk" + "?url="+uri+"&num="+Math.random();
		axios.get(url).then(response => {
			that.shareConfig = response.data;
			that.initWxConfig();
		})
		.catch(error => {});
	}
	this.shareAction = function(){
		let that = this;
		if(!this.shareConfig){
			Toast.fail({
			  message: '初始化未完成，请稍候重试！'
			})
			return false;
		}else{
			if(this.chkWeiXin()){
				Toast.success({
				  message: '请点击右上角 ··· 分享！'
				})
			}else{
				var nativeShare = new NativeShare({
					wechatConfig: that.shareConfig,
					// 让你修改的分享的文案同步到标签里，比如title文案会同步到<title>标签中
					// 这样可以让一些不支持分享的浏览器也能修改部分文案，默认都不会同步
					syncDescToTag: true,
					syncIconToTag: true,
					syncTitleToTag: true,
				})
	 
	 
				// 设置分享文案
				nativeShare.setShareData({
					icon: that.shareInfo.imgUrl,
					link: that.shareInfo.link,
					title: that.shareInfo.title,
					desc: that.shareInfo.desc,
					from: '@pg',
				})
	 
				// 唤起浏览器原生分享组件(如果在微信中不会唤起，此时call方法只会设置文案。类似setShareData)
				try {
					nativeShare.call()
					// 如果是分享到微信则需要 nativeShare.call('wechatFriend')
					// 类似的命令下面有介绍
				} catch(err) {
					// 如果不支持，你可以在这里做降级处理
					Toast.fail({
					  message: '该浏览器不支持自动分享,请手动分享'
					})
				}
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/utils/wxShareUtil.js